export const ModalService = angular
    .module('checkout.services.modalService', [
        'ngMaterial'
    ]).service('modalService', ($mdDialog, $window) => {
        function open(options) {
            return $mdDialog.cancel().then(() => {
                const modalBodyClass = 'checkout-modal-overrides';
                angular.element($window.document.body).addClass(modalBodyClass);
                return $mdDialog.show({
                    controller: ['$scope', ($scope) => {
                        angular.extend($scope, options.data);
                    }],
                    onComplete: () => {
                        $window.document.querySelector('.md-dialog-container').scrollTop = 0;
                    },
                    template: `
                        <md-dialog class="checkout checkout-modal ${options.cssClass}">${options.template}</md-dialog>
                    `,
                    targetEvent: options.$event,
                    clickOutsideToClose: options.clickOutsideToClose
                }).finally((response) => {
                    angular.element($window.document.body).removeClass(modalBodyClass);
                    return response;
                });
            });
        }

        return {
            open
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/modal.service.js